export enum SpaceConfig {
  wide = 6,
  normal = 4,
  tight = 1,
  none = 0,
}
